export default __webpack_public_path__ + "bb0ea4df259b135a6f477a5251b1c8fd.png";